<template>
  <hm-content title>
    <div class="table-panel flex flex-end">
      <div class="flex-1">
        <el-select
          size="small"
          clearable
          class="mr10"
          placeholder="请选择商户"
          v-model="searchCondition.storeCode"
          filterable
          remote
          :remote-method="remoteMethod"
        >
          <el-option
            :label="item.storeName"
            :value="item.storeCode"
            v-for="(item) in storeBasicList"
            :key="item.storeCode"
          >
          </el-option>
        </el-select>
        <el-select
          size="small"
          clearable
          class="mr10"
          placeholder="请选择门店"
          v-model="searchCondition.shopId"
          filterable
          :disabled="searchCondition.storeCode === ''"
        >
          <el-option
            :label="item.shopName"
            :value="item.shopId"
            v-for="(item, i) in shopList"
            :key="i"
          >
          </el-option>
        </el-select>
        <el-select
          size="small"
          clearable
          class="mr10"
          placeholder="选择收红包角色"
          v-model="searchCondition.roleType"
          style="width: 200px"
          filterable
        >
          <el-option label="导购" value="guider"></el-option>
          <el-option label="推会员" value="shareMember"></el-option>
          <el-option label="导购/推会员" value="both"></el-option>
        </el-select>
        <el-cascader
          :options="area"
          class="mr10"
          size="small"
          ref="citys"
          clearable
          placeholder="导购推会员省市区"
          v-model="searchCondition.citys"
          :props="props"
        ></el-cascader>
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.keyword"
          placeholder="请输入导购姓名/推会员姓名/电话号码"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchCondition.applyDate"
          type="datetimerange"
          range-separator="至"
          start-placeholder="选择创建时间段"
          end-placeholder="选择创建时间段"
        ></el-date-picker>
      </div>
      <div>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output('queryAllList', '红包统计', 'table')"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <el-table
      :data="list"
      style="width: 100%"
      ref="table"
      stripe
      border
      size="small"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="电话号码"
        prop="authMobile"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="姓名"
        prop="idcardName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="身份证号"
        prop="idcardNo"
      ></el-table-column>

      <el-table-column
        header-align="center"
        align="center"
        label="收红包角色"
        prop="templateType"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.roleType === 'shareMember'">推会员</span>
          <span v-if="scope.row.roleType === 'guider'">导购</span>
          <span v-if="scope.row.roleType === 'both'">推会员/导购</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        header-align="center"
        align="center"
        prop="provinceName"
        label="所在省"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="cityName"
        label="所在市"
      ></el-table-column> -->
      <el-table-column
        header-align="center"
        align="center"
        label="所在省/市/区"
        prop="citys"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.provinceName }}{{ scope.row.cityName
            }}{{ scope.row.districtName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="totalMoneyProfitAmount"
        label="累计收益"
      >
        <template slot-scope="scope">
          {{ scope.row.totalMoneyProfitAmount }}
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="hasGetcashMoneyAmount"
        label="已提现"
      >
        <template slot-scope="scope">
          {{ scope.row.hasGetcashMoneyAmount }}
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="allowGetcashMoneyAmount"
          label="可提现金额"
      >
        <template slot-scope="scope">
          {{ scope.row.allowGetcashMoneyAmount }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        header-align="center"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-button size="small" type="text" @click="detailsGuide(scope.row)"
              >会员信息</el-button
            >
            <el-button
              size="small"
              type="text"
              v-if="
                scope.row.roleType === 'guider' || scope.row.roleType === 'both'
              "
              @click="detailsDaoGou(scope.row)"
              >导购账单</el-button
            >
            <el-button
              size="small"
              v-if="
                scope.row.roleType === 'shareMember' ||
                  scope.row.roleType === 'both'
              "
              type="text"
              @click="detailsSales(scope.row)"
              >分销账单</el-button
            >
            <el-button
                size="small"
                type="text"
                @click="goFlowList(scope.row)"
            >资金流水</el-button
            >
            <el-button
              size="small"
              type="text"
              @click="detailsWithdraw(scope.row)"
              >提现账单</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @size-change="handleSizeChange"
        @current-change="paging"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>

    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="75%"
    >
      <div v-if="type === 'guide'">
        <div class="modal-table mb20">
          <div class="table-header flex">
            <div class="flex-1">姓名</div>
            <div class="flex-1">电话</div>
            <div class="flex-1">身份证号</div>
            <div class="flex-1" v-if="currentRoleType !== 'shareMember'">
              所属商户
            </div>
            <div class="flex-1" v-if="currentRoleType !== 'shareMember'">
              所属门店
            </div>
            <div class="flex-1" v-if="currentRoleType !== 'shareMember'">
              门店地址
            </div>
          </div>
          <div class="table-body flex">
            <div class="flex-1">{{ memberInfo.idcardName }}</div>
            <div class="flex-1">{{ memberInfo.authMobile }}</div>
            <div class="flex-1">{{ memberInfo.idcardNo }}</div>
            <div class="flex-1" v-if="currentRoleType !== 'shareMember'">
              {{ memberInfo.storeName }}
            </div>
            <div class="flex-1" v-if="currentRoleType !== 'shareMember'">
              {{ memberInfo.shopName }}
            </div>
            <div class="flex-1" v-if="currentRoleType !== 'shareMember'">
              {{ memberInfo.shopAddress }}
            </div>
          </div>
        </div>
        <div class="mb20" v-if="currentRoleType !== 'shareMember'">
          已加入品牌: {{ memberInfo.hasJoinBrand }}
        </div>
        <div class="mb20" v-if="currentRoleType !== 'guider'">
          分销商城: {{ memberInfo.shareStore }}
        </div>
        <div class="mb20" v-if="currentRoleType !== 'shareMember'">
          工牌照片:
          <div>
            <el-image
              style="width: 200px; height: 200px"
              class="mr10"
              :src="memberInfo.workCardImg"
              :preview-src-list="[memberInfo.workCardImg]"
            ></el-image>
          </div>
        </div>
        <div class="mb20" v-if="currentRoleType !== 'shareMember'">
          门店门头照片:
          <div>
            <el-image
              style="width: 200px; height: 200px"
              class="mr10"
              :src="memberInfo.outletImg"
              :preview-src-list="[memberInfo.outletImg]"
            ></el-image>
          </div>
        </div>
      </div>
      <div v-if="type === 'withdraw'">
        <div class="modal-table mb20">
          <div class="table-header flex">
            <div class="flex-1">姓名</div>
            <div class="flex-1">电话</div>
            <div class="flex-1">身份证号</div>
          </div>
          <div class="table-body flex">
            <div class="flex-1">{{ currentRow.idcardName }}</div>
            <div class="flex-1">{{ currentRow.authMobile }}</div>
            <div class="flex-1">{{ currentRow.idcardNo }}</div>
          </div>
        </div>
        <div class="table-panel flex flex-end">
          <div class="flex-1 text-right">
            <el-input
              clearable
              style="width: 200px"
              v-model.trim="withdrawConditions.getcashSn"
              placeholder="请输入提现单号"
              size="small"
              class="ipt mr10"
            ></el-input>
            <el-date-picker
              v-model="withdrawConditions.getcachApplyTime"
              type="datetimerange"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="选择申请时间段"
              end-placeholder="选择申请时间段"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              clearable
            ></el-date-picker>
            <el-date-picker
              v-model="withdrawConditions.auditTime"
              type="datetimerange"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="选择审核时间段"
              end-placeholder="选择审核时间段"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              clearable
            ></el-date-picker>

            <el-button
              type="primary"
              size="small"
              @click="queryWithDrawOrderList(currentRow)"
              >查询</el-button
            >
            <el-button
              type="success"
              size="small"
              @click="
                output('queryAllWithDrawOrderList', '提现账单', 'tableTx')
              "
              :loading="isOutputing"
              >导出</el-button
            >
          </div>
        </div>
        <div class="table">
          <el-table
            stripe
            border
            :data="widthDrawList"
            size="small"
            ref="tableTx"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="getcashSn"
              label="提现单号"
            >
              <template slot-scope="scope">
                {{ scope.row.getcashSn }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="getcachApplyTime"
              label="申请时间"
            >
              <template slot-scope="scope">
                {{ scope.row.getcachApplyTime }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="auditTime"
              label="审核时间"
            >
              <template slot-scope="scope">
                {{ scope.row.auditTime }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="auditUsername"
              label="审核人"
            >
              <template slot-scope="scope">
                {{ scope.row.auditUsername }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="提现金额"
              prop="getcashMoney"
            >
              <template slot-scope="scope">
                <span class="primary">￥{{ scope.row.getcashMoney }}</span>
              </template>
            </el-table-column>
          </el-table>

          <div class="hm-pagination">
            <el-pagination
              background
              :total="widthDrawListTotal"
              @current-change="withDrawpaging"
              @size-change="handleWithDrawSizeChange"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="withdrawCurrentPage"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div v-if="type === 'daoGou'">
        <div class="modal-table mb20">
          <div class="table-header flex">
            <div class="flex-1">姓名</div>
            <div class="flex-1">电话</div>
            <div class="flex-1">身份证号</div>
          </div>
          <div class="table-body flex">
            <div class="flex-1">{{ currentRow.idcardName }}</div>
            <div class="flex-1">{{ currentRow.authMobile }}</div>
            <div class="flex-1">{{ currentRow.idcardNo }}</div>
          </div>
        </div>
        <div class="table-panel flex flex-between">
          <div>
            <el-radio-group
              v-model="auditState"
              size="small"
              @change="subjectTypeChange"
            >
              <el-radio-button label="agree">收益</el-radio-button>
              <el-radio-button label="refund">退款</el-radio-button>
            </el-radio-group>
          </div>
          <div class="flex-1 text-right">
            <el-date-picker
              v-model="declareTime"
              type="datetimerange"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="选择上传时间段"
              end-placeholder="选择上传时间段"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              clearable
            ></el-date-picker>
            <el-button
              type="primary"
              size="small"
              @click="queryGuiderOrderList(currentRow)"
              >查询</el-button
            >
            <el-button
              v-if="auditState === 'agree'"
              type="success"
              size="small"
              @click="
                output('queryAllGuiderOrderList', '导购收益账单', 'tableDg')
              "
              :loading="isOutputing"
              >导出</el-button
            >
            <el-button
              v-if="auditState === 'refund'"
              type="success"
              size="small"
              @click="
                output('queryAllGuiderOrderList', '导购退款账单', 'tableDg')
              "
              :loading="isOutputing"
              >导出</el-button
            >
          </div>
        </div>
        <div class="table">
          <el-table
            key="receiptId"
            stripe
            border
            :data="guiderList"
            ref="tableDg"
            size="small"
            v-if="resetForm"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="refundSn"
              label="退款单号"
              v-if="auditState === 'refund'"
            >
              <template slot-scope="scope">
                {{ scope.row.refundSn }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="declareSn"
              label="申报单号"
            >
              <template slot-scope="scope">
                {{ scope.row.declareSn }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="receiptSn"
              label="小票号"
            >
              <template slot-scope="scope">
                {{ scope.row.receiptSn }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="declareTime"
              label="申报时间"
            >
              <template slot-scope="scope">
                {{ scope.row.declareTime }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="receiptDate"
              label="小票日期"
            >
              <template slot-scope="scope">
                {{ scope.row.receiptDate }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsNum"
              label="销售商品数量"
            >
              <template slot-scope="scope">
                {{ scope.row.goodsNum }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="redpackageMoney"
              :label="auditState === 'agree' ? '总计收益' : '总计退款'"
            >
              <template slot-scope="scope">
                <span class="primary">
                  {{ auditState === "agree" ? "" : "-" }} ￥{{
                    scope.row.redpackageMoney
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button
                    size="small"
                    type="text"
                    @click="details(scope.row)"
                    >查看详情</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div class="hm-pagination">
            <el-pagination
              background
              :total="guiderListTotal"
              @current-change="guiderPaging"
              @size-change="handleGuiderSizeChange"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="guiderCurrentPage"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div v-if="type === 'fenXiao'">
        <div class="modal-table mb20">
          <div class="table-header flex">
            <div class="flex-1">姓名</div>
            <div class="flex-1">电话</div>
            <div class="flex-1">身份证号</div>
          </div>
          <div class="table-body flex">
            <div class="flex-1">{{ currentRow.idcardName }}</div>
            <div class="flex-1">{{ currentRow.authMobile }}</div>
            <div class="flex-1">{{ currentRow.idcardNo }}</div>
          </div>
        </div>
        <div class="table-panel flex flex-between">
          <div>
            <el-radio-group
              v-model="commissionType"
              size="small"
              @change="switchTab"
            >
              <el-radio-button label="share">分销佣金</el-radio-button>
              <el-radio-button label="agent">代理奖励</el-radio-button>
            </el-radio-group>
          </div>
          <div class="flex-1 text-right">
            <el-date-picker
              v-model="unlockTime"
              type="datetimerange"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="选择解锁时间段"
              end-placeholder="选择解锁时间段"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              clearable
            ></el-date-picker>
            <el-button
              type="primary"
              size="small"
              @click="queryShareOrderList(currentRow)"
              >查询</el-button
            >
            <el-button
              type="success"
              size="small"
              @click="output('queryAllShareOrderList', '分销账单', 'tableFx')"
              :loading="isOutputing"
              >导出账单</el-button
            >
          </div>
        </div>
        <div class="table">
          <el-table stripe border :data="shareList" ref="tableFx" size="small">
            <el-table-column
              header-align="center"
              align="center"
              prop="orderSn"
              label="订单号"
            >
              <template slot-scope="scope">
                {{ scope.row.orderSn }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="commissionLevel"
              label="佣金级别"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.commissionType === 'agent'">
                  代理奖励
                </div>
                <div v-else>{{ scope.row.commissionLevel }}级分销</div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="payTime"
              label="付款日期"
            >
              <template slot-scope="scope">
                {{ scope.row.payTime }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="commissionState"
              label="解锁状态"
            >
              <template slot-scope="scope">
                <div
                  :class="
                    scope.row.commissionState === 'use' ? 'success' : 'danger'
                  "
                >
                  {{ scope.row.commissionState === "use" ? "可用" : "锁定" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="actuallyPrice"
              label="订单金额"
            >
              <template slot-scope="scope">
                <span class="primary">￥{{ scope.row.actuallyPrice }}</span>
              </template>
            </el-table-column>

            <el-table-column
              header-align="center"
              align="center"
              prop="commissionMoney"
              label="总计收益"
            >
              <template slot-scope="scope">
                <span class="primary">￥{{ scope.row.commissionMoney }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button size="small" type="text" @click="detail(scope.row)"
                    >查看详情</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div class="hm-pagination">
            <el-pagination
              background
              :total="shareListTotal"
              @current-change="shareListPaging"
              @size-change="handleShareListSizeChange"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="shareOrderPageNo"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div v-if="type === 'flowList'">
        <div class="modal-table mb20">
          <div class="table-header flex">
            <div class="flex-1">姓名</div>
            <div class="flex-1">电话</div>
            <div class="flex-1">身份证号</div>
          </div>
          <div class="table-body flex">
            <div class="flex-1">{{ currentRow.idcardName }}</div>
            <div class="flex-1">{{ currentRow.authMobile }}</div>
            <div class="flex-1">{{ currentRow.idcardNo }}</div>
          </div>
        </div>
        <div class="table-panel flex flex-end">
          <div class="flex-1 text-right">
            <el-date-picker
                v-model="flowAuditTime"
                type="datetimerange"
                align="right"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="选择时间段"
                end-placeholder="选择时间段"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
                clearable
            ></el-date-picker>
            <el-button
                type="primary"
                size="small"
                @click="queryGuiderFlowList(currentRow)"
            >查询</el-button
            >
          </div>
        </div>
        <div class="table">
          <el-table
              key="receiptId"
              stripe
              border
              :data="flowList"
              ref="tableDg"
              size="small"
          >
            <el-table-column
                header-align="center"
                align="center"
                prop="tradeTime"
                label="交易时间"
            >
              <template slot-scope="scope">
                {{ scope.row.tradeTime }}
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="billSn"
                label="交易单号"
            >
              <template slot-scope="scope">
                {{ scope.row.billSn }}
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="declareTime"
                label="交易类型"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.flowType == 'store_profit'">品牌奖励</span>
                <span v-else-if="scope.row.flowType == 'guider_refund'">退单</span>
                <span v-else-if="scope.row.flowType == 'store_share_refund'">分成退单</span>
                <span v-else-if="scope.row.flowType == 'corporate_store_profit' || scope.row.flowType == 'private_store_profit'">商户管理费</span>
                <span v-else-if="scope.row.flowType == 'video_ad'">赠送收入</span>
                <span v-else>商城收益</span>
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="tradeMoney"
                label="收支金额"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.tradeMode == 'in'">+</span><span v-else>-</span>{{ scope.row.tradeMoney }}
              </template>
            </el-table-column>
          </el-table>

          <div class="hm-pagination">
            <el-pagination
                background
                :total="flowListTotal"
                @current-change="flowListPaging"
                @size-change="handleFlowListSizeChange"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="flowListCurrentPage"
            ></el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="账单详情"
      :close-on-click-modal="false"
      :visible.sync="dialogDeclare"
      width="800px"
    >
      <div>
        <div class="modal-table mb20">
          <div class="table-header flex">
            <div class="flex-1">导购姓名</div>
            <div class="flex-1">电话</div>
            <div class="flex-1" v-if="auditState === 'agree'">申报单号</div>
            <div class="flex-1" v-else>退款单号</div>
            <div class="flex-1">申报日期</div>
            <div class="flex-1">小票日期</div>
          </div>
          <div class="table-body flex">
            <div class="flex-1">{{ guiderDetails.guiderName }}</div>
            <div class="flex-1">{{ guiderDetails.guiderPhone }}</div>
            <div class="flex-1" v-if="auditState === 'agree'">{{ guiderDetails.declareSn }}</div>
            <div class="flex-1" v-else>{{ guiderDetails.refundSn }}</div>
            <div class="flex-1">{{ guiderDetails.declareTime }}</div>
            <div class="flex-1">{{ guiderDetails.receiptTime }}</div>
          </div>
        </div>
        <div class="mb20 flex flex-wrap">
          <!-- <div
            style="width:100px;height:100px"
            class="mr10"
            v-for="(v, i) in guiderDetails.declareImgList"
            :key="i"
          >
            <img :src="v" alt style="width:100%" />
          </div> -->
          <template v-if="this.auditState === 'agree'">
            <el-image
              v-for="(v, i) in guiderDetails.declareImgList"
              :key="i"
              style="width: 100px; height: 100px"
              class="mr10"
              :src="v"
              :preview-src-list="guiderDetails.declareImgList"
            ></el-image>
          </template>
        </div>
        <div class="table" v-if="this.auditState === 'agree'">
          <el-table
            stripe
            border
            :data="billDetailsBoList"
            size="small"
            :span-method="objectSpanMethod"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="rewardName"
              label="活动名称"
              key="rewardName"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="brandName"
              label="品牌"
              key="brandName"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsName"
              label="商品"
              key="goodsName"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsNum"
              label="销售商品数量"
              key="goodsNum"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="redpackageMoney"
              label="收益基数"
              key="redpackageMoney"
            >
              <template slot-scope="scope">
                <span class="primary">{{
                  (scope.row.redpackageMoney / scope.row.goodsNum).toFixed(2)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="tradeMoney"
              label="计算收益"
              key="tradeMoney"
            >
              <template slot-scope="scope">
                <span class="primary">￥{{ scope.row.tradeMoney }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="flex flex-end mt10">
            总计提成:
            <span class="primary" style="fontSize:18px;"
              >￥{{ totalRedpackageMoney }}</span
            >
          </div>
        </div>
        <div class="table" v-if="this.auditState === 'refund'">
          <el-table stripe border :data="billDetailsBoList" size="small">
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsName"
              label="商品名称"
              key="goodsName"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="brandName"
              label="品牌"
              key="brandName"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsNum"
              label="商品数量"
              key="goodsNum"
            ></el-table-column>

            <el-table-column
              header-align="center"
              align="center"
              prop="refundAmount"
              label="退款金额"
              key="refundAmount"
            >
              <template slot-scope="scope">
                <span class="primary">-￥{{ scope.row.refundAmount }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="flex flex-end mt10">
            总计退款:
            <span class="primary" style="fontSize:18px;"
              >-￥{{ totalRedpackageMoney }}</span
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="账单详情"
      :close-on-click-modal="false"
      :visible.sync="dialogDeclares"
      width="1200px"
    >
      <div>
        <div class="modal-table mb20">
          <div class="table-header flex">
            <div class="flex-1">会员姓名</div>
            <div class="flex-1">电话</div>
            <div class="flex-1">订单号</div>
          </div>
          <div class="table-body flex">
            <div class="flex-1">{{ currentRow.idcardName }}</div>
            <div class="flex-1">{{ currentRow.authMobile }}</div>
            <div class="flex-1">{{ detailsFx.orderSn }}</div>
          </div>
        </div>
        <div class="table detail">
          <el-table
            stripe
            style="width: 100%"
            ref="table"
            id="table"
            size="small"
            :data="billDetail"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsImg"
              label="商品图片"
            >
              <template slot-scope="scope">
                <div>
                  <!-- <img
                        class="warning-tuikuan"
                        v-show="scope.row.returnType === 'yes'"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                        alt=""
                      />
                      <img
                        class="warning-tuikuan"
                        v-show="scope.row.returnType === 'doing'"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                        alt=""
                      /> -->

                  <img
                    style="width:100px;height:100px;"
                    v-if="scope.row.goodsImg"
                    :src="scope.row.goodsImg"
                    alt=""
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="商品名称/品牌"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.spuName }}</p>
                <p>品牌: {{ scope.row.brandName }}</p>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="价格/货号"
            >
              <template slot-scope="scope">
                <p>价格: {{ scope.row.totalPrice }}</p>
                <p>货号: {{ scope.row.goodsSn }}</p>
                <p>条码: {{ scope.row.barCode }}</p>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="净重/毛重"
            >
              <template slot-scope="scope">
                <p v-if="scope.row.netWeight">
                  净重: {{ scope.row.netWeight }}
                </p>
                <p v-if="scope.row.grossWeight">
                  毛重: {{ scope.row.grossWeight }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="specIdGroupName"
              label="规格"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsNum"
              label="数量"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="totalPrice"
              label="小计"
            >
              <template slot-scope="scope">
                <p>￥{{ scope.row.totalPrice * scope.row.goodsNum }}</p>
              </template>
            </el-table-column>

            <el-table-column
              header-align="center"
              align="center"
              prop="commissionMoney"
              label="佣金"
            >
              <template slot-scope="scope">
                <div class="primary">{{ scope.row.commissionMoney }}元</div>
              </template>
            </el-table-column>
          </el-table>
          <div class="total-price flex flex-end">
            佣金总计：<span class="primary mr10"
              >{{ commissionTotalMoney }}元</span
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import area from "@/utils/area";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      auditState: "agree",
      position: 0,
      rowSpanArr: [],
      area,
      list: [],
      total: 0,
      props: {
        value: "value",
        children: "children"
      },
      title: "",
      withdrawConditions: {},
      currentRow: {},
      billDetail: [],
      guiderList: [],
      guiderListTotal: 0,
      declareTime: [],
      widthDrawList: [],
      widthDrawListTotal: 0,
      currentPage: 1,
      unlockTime: [],
      pageSize: 10,
      shareOrderPageNo: 1,
      guiderPageSize: 10,
      guiderCurrentPage: 1,
      withdrawPageSize: 10,
      withdrawCurrentPage: 1,
      shareList: [],
      shareListTotal: 0,
      shareOrderPageSize: 10,
      dialogVisible: false,
      dialogDeclare: false,
      dialogDeclares: false,
      searchCondition: {
        storeCode: "",
        shopId: "",
        applyDate: [],
      },
      show: false,
      storeTemplateId: "",
      isOutputing: false,
      type: "sales",
      memberInfo: {},
      currentRoleType: "",
      guiderDetails: {},
      commissionType: "share",
      detailsFx: {},
      commissionTotalMoney: 0,
      billDetailsBoList: [],
      totalRedpackageMoney: 0,
      shopList: [],
      storeBasicList: [],
      flowListCurrentPage: 1,
      flowListPageSize: 10,
      flowListTotal: 0,
      flowAuditTime: [],
      flowList: [],
      allStoreBasicList: [],
      resetForm: true,
      // Shopprops: {
      //   lazy: true,
      //   checkStrictly: true,
      //   multiple: true,
      //   lazyLoad: (node, resolve) => {
      //     const { level, data } = node;
      //     if (level === 0) {
      //       this.$store
      //         .dispatch("queryStoreBasicList", {
      //           pageNo: 1,
      //           pageSize: 9999
      //         })
      //         .then(res => {
      //           res.result.records.forEach(v => {
      //             v.leaf = Boolean(v.shopCount > 0 ? false : true);
      //             v.value = v.storeCode;
      //             v.label = v.storeName;
      //           });
      //           resolve(res.result.records);
      //         });
      //     } else if (level === 1) {
      //       this.$store
      //         .dispatch("queryStoreShopInfoList", {
      //           storeCode: data.storeCode
      //         })
      //         .then(res => {
      //           if (res.code === "0" && res.result) {
      //             res.result.records.forEach(v => {
      //               v.leaf = true;
      //               v.value = v.shopId;
      //               v.label = v.shopName;
      //             });
      //             resolve(res.result.records);
      //           } else {
      //             resolve([]);
      //           }
      //         });
      //     } else {
      //       resolve([]);
      //     }
      //   }
      // }
    };
  },
  watch: {},
  created() {
    const startTime = moment().startOf("day").subtract(6, "days").format("YYYY-MM-DD HH:mm:ss");
    const endTime = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    this.searchCondition.applyDate = [startTime, endTime];
  },
  mounted() {
    this.queryList();
    this.queryStoreBasicList();
  },
  methods: {
    queryGuiderFlowList(row) {
      this.flowListCurrentPage = 1;
      this.queryFlowList(row);
    },
    async queryFlowList(row) {
      let params = {
        pageNo: this.flowListCurrentPage,
        pageSize: this.flowListPageSize,
        customerId: row.customerId,
        auditStartTime:
            this.flowAuditTime && this.flowAuditTime.length
                ? this.flowAuditTime[0]
                : "",
        auditEndTime:
            this.flowAuditTime && this.flowAuditTime.length ? this.flowAuditTime[1] : ""
      }
      const { result } = await this.$store.dispatch("queryGuiderFlowList", params);
      this.flowList = result.order.records;
      this.flowListTotal = result.order.total;
    },
    storeCodeChange(val) {
      this.searchCondition.shopId = "";
      this.queryShopIdList(val);
    },
    async queryShopIdList(storeCode) {
      const { result } = await this.$store.dispatch("queryStoreShopInfoList", {
        pageNo: 1,
        pageSize: 9999,
        storeCode
      });

      this.shopList = result.records;
    },
    switchTab() {
      this.shareOrderPageNo = 1;
      this.queryShareOrderList(this.currentRow);
    },
    async queryList() {
      let shopProvinceCode = "";
      let shopCityCode = "";
      let conditions = JSON.parse(JSON.stringify(this.searchCondition));
      if (conditions.citys && conditions.citys.length) {
        shopProvinceCode = conditions.citys[0];
        shopCityCode = conditions.citys[1];
        delete conditions.citys;
      }
      conditions.firstAuthTimeStart =
        this.searchCondition.applyDate && this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      conditions.firstAuthTimeEnd =
        this.searchCondition.applyDate && this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        shopProvinceCode,
        shopCityCode
      };
      Object.assign(params, conditions);
      const { result } = await this.$store.dispatch(
        "queryRedPacketList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    queryAllList() {
      let shopProvinceCode = "";
      let shopCityCode = "";
      let conditions = JSON.parse(JSON.stringify(this.searchCondition));
      if (conditions.citys && conditions.citys.length) {
        shopProvinceCode = conditions.citys[0];
        shopCityCode = conditions.citys[1];
        delete conditions.citys;
      }
      let params = {
        pageSize: 9999999,
        pageNo: 1,
        shopProvinceCode,
        shopCityCode
      };
      Object.assign(params, conditions);
      return this.$store.dispatch("queryRedPacketList", params);
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async detailsGuide(row) {
      this.title = "会员信息";
      this.type = "guide";
      this.dialogVisible = true;
      const { result } = await this.$store.dispatch("queryRedPacketRoleInfo", {
        customerId: row.customerId,
        roleType: row.roleType
      });
      this.currentRoleType = row.roleType;
      this.memberInfo = result;
      this.currentRow = row;
    },
    async detailsSales(row) {
      this.title = "分销账单";
      this.type = "fenXiao";
      this.dialogVisible = true;
      this.currentRow = row;
      this.queryShareOrderList(row);
    },
    async goFlowList(row) {
      this.title = "资金流水";
      this.type = "flowList";
      this.dialogVisible = true;
      this.currentRow = row;
      this.queryFlowList(row);
    },
    async queryShareOrderList(row) {
      const { result } = await this.$store.dispatch("queryShareOrderListNew", {
        commissionType: this.commissionType,
        shareCenterId: row.shareCenterId,
        pageSize: this.shareOrderPageSize,
        pageNo: this.shareOrderPageNo,
        unlockStartTime: this.unlockTime ? this.unlockTime[0] : "",
        unlockEndTime: this.unlockTime ? this.unlockTime[1] : ""
      });
      const { records, total } = result;
      this.shareList = records;
      this.shareListTotal = total;
    },
    async queryAllShareOrderList() {
      const { result } = await this.$store.dispatch(
        "queryAllShareOrderListNew",
        {
          commissionType: this.commissionType,
          shareCenterId: this.currentRow.shareCenterId,
          pageSize: 999999,
          pageNo: 1,
          unlockStartTime: this.unlockTime ? this.unlockTime[0] : "",
          unlockEndTime: this.unlockTime ? this.unlockTime[1] : ""
        }
      );
      result.records.forEach(v => {
        if (v.commissionType === "agent") {
          v.commissionLevel = "代理奖励";
        } else {
          v.commissionLevel = v.commissionLevel + "级分销";
        }
        if (v.commissionState === "use") {
          v.commissionState = "可用";
        } else {
          v.commissionState = "锁定";
        }
      });
      let res = {
        result
      };
      return res;
    },
    flowListPaging(page) {
      this.flowListCurrentPage = page;
      this.queryFlowList(this.currentRow);
    },
    handleFlowListSizeChange(size) {
      this.flowListCurrentPage = 1;
      this.flowListPageSize = size;
      this.queryFlowList(this.currentRow);
    },
    shareListPaging(page) {
      this.shareOrderPageNo = page;
      this.queryShareOrderList(this.currentRow);
    },
    handleShareListSizeChange(size) {
      this.shareOrderPageNo = 1;
      this.shareOrderPageSize = size;
      this.queryShareOrderList(this.currentRow);
    },
    guiderPaging(page) {
      this.guiderCurrentPage = page;
      this.queryGuiderOrderList(this.currentRow);
    },
    handleGuiderSizeChange(size) {
      this.guiderCurrentPage = 1;
      this.guiderPageSize = size;
      this.queryGuiderOrderList(this.currentRow);
    },
    withDrawpaging(page) {
      this.withdrawCurrentPage = page;
      this.queryWithDrawOrderList(this.currentRow);
    },
    handleWithDrawSizeChange(size) {
      this.withdrawCurrentPage = 1;
      this.withdrawPageSize = size;
      this.queryWithDrawOrderList(this.currentRow);
    },
    async detailsWithdraw(row) {
      this.title = "提现账单";
      this.type = "withdraw";
      this.dialogVisible = true;
      this.currentRow = row;
      this.queryWithDrawOrderList(this.currentRow);
    },
    async queryWithDrawOrderList(row) {
      let params = {
        customerId: row.customerId,
        pageNo: this.withdrawCurrentPage,
        pageSize: this.withdrawPageSize
      };
      let conditions = JSON.parse(JSON.stringify(this.withdrawConditions));
      if (conditions.getcachApplyTime && conditions.getcachApplyTime.length) {
        conditions.getcachApplyStartTime = conditions.getcachApplyTime[0];
        conditions.getcachApplyEndTime = conditions.getcachApplyTime[1];
        delete conditions.getcachApplyTime;
      }
      if (conditions.auditTime && conditions.auditTime.length) {
        conditions.auditStartTime = conditions.auditTime[0];
        conditions.auditEndTime = conditions.auditTime[1];
        delete conditions.auditTime;
      }
      Object.assign(params, conditions);
      // withdrawConditions
      const { result } = await this.$store.dispatch(
        "queryWithDrawOrderList",
        params
      );
      const { records, total } = result;
      this.widthDrawList = records;
      this.widthDrawListTotal = total;
    },
    queryAllWithDrawOrderList() {
      let params = {
        customerId: this.currentRow.customerId,
        pageNo: 1,
        pageSize: 999999
      };
      let conditions = JSON.parse(JSON.stringify(this.withdrawConditions));
      if (conditions.getcachApplyTime && conditions.getcachApplyTime.length) {
        conditions.getcachApplyStartTime = conditions.getcachApplyTime[0];
        conditions.getcachApplyEndTime = conditions.getcachApplyTime[1];
        delete conditions.getcachApplyTime;
      }
      if (conditions.auditTime && conditions.auditTime.length) {
        conditions.auditStartTime = conditions.auditTime[0];
        conditions.auditEndTime = conditions.auditTime[1];
        delete conditions.auditTime;
      }
      Object.assign(params, conditions);
      return this.$store.dispatch("queryAllWithDrawOrderList", params);
    },
    detailsDaoGou(row) {
      this.title = "导购账单";
      this.type = "daoGou";
      this.auditState = "agree";
      this.guiderPageSize = 10;
      this.guiderCurrentPage = 1;
      this.dialogVisible = true;
      this.currentRow = row;
      this.queryGuiderOrderList(this.currentRow);
    },
    subjectTypeChange() {
      this.resetForm = false;
      this.$nextTick(() => {
        this.resetForm = true;
      });
      this.guiderPageSize = 10;
      this.guiderCurrentPage = 1;
      this.queryGuiderOrderList(this.currentRow);
    },
    async queryGuiderOrderList(row) {
      const { result } = await this.$store.dispatch("queryGuiderOrderList", {
        guiderId: row.guiderId,
        pageSize: this.guiderPageSize,
        pageNo: this.guiderCurrentPage,
        auditState: this.auditState,
        declareStartTime:
          this.declareTime && this.declareTime.length
            ? this.declareTime[0]
            : "",
        declareEndTime:
          this.declareTime && this.declareTime.length ? this.declareTime[1] : ""
      });
      const { records, total } = result;
      this.guiderList = records;
      this.guiderListTotal = total;
    },
    queryAllGuiderOrderList() {
      return this.$store.dispatch("queryAllGuiderOrderList", {
        auditState: this.auditState,
        guiderId: this.currentRow.guiderId,
        pageSize: 99999,
        pageNo: this.guiderCurrentPage,
        declareStartTime:
          this.declareTime && this.declareTime.length
            ? this.declareTime[0]
            : "",
        declareEndTime:
          this.declareTime && this.declareTime.length ? this.declareTime[1] : ""
      });
    },
    getRowSpan() {
      this.rowSpanArr = [];
      this.billDetailsBoList.forEach((item, index) => {
        if (index == 0) {
          this.rowSpanArr.push(1);
          this.position = 0;
        } else {
          if (
            this.billDetailsBoList[index].rewardRuleId ==
            this.billDetailsBoList[index - 1].rewardRuleId
          ) {
            this.rowSpanArr[this.position] += 1; //项目名称相同，合并到同一个数组中
            this.rowSpanArr.push(0);
            this.billDetailsBoList[index].rewardRuleId = this.billDetailsBoList[
              index - 1
            ].rewardRuleId;
          } else {
            this.rowSpanArr.push(1);
            this.position = index;
          }
        }
      });
      this.billDetailsBoList = [...this.billDetailsBoList];
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      // 只合并区域位置

      if (columnIndex === 0 || columnIndex === 5) {
        const _row = this.rowSpanArr[rowIndex];

        return {
          rowspan: _row, //行
          colspan: 1 //列
        };
      }
    },
    async details(row) {
      this.dialogDeclare = true;
      let declareSn = "";
      if(this.auditState === 'agree' ){
        declareSn = row.declareSn
      }else{
        declareSn = row.refundSn
      }
      const { result } = await this.$store.dispatch("viewGuiderOrderDetails", {
        auditState: this.auditState,
        declareSn
      });
      if (this.auditState === "agree") {
        this.totalRedpackageMoney = row.redpackageMoney;
        let list = [];
        result.rewardRuleInfoModelList.forEach(v => {
          v.billDetailsBoList.forEach(j => {
            j.rewardName = v.rewardName;
            j.tradeMoney = v.companyCapitalFlowModel.tradeMoney;
            list.push(j);
          });
        });

        this.billDetailsBoList = list;
        this.getRowSpan();
        this.guiderDetails = result;
      } else if (this.auditState === "refund") {
        this.guiderDetails = row;
        this.totalRedpackageMoney = result.totalRefundAmount;
        this.billDetailsBoList = result.refundBillDetailsModelList;
      }

      // this.guiderDetails.totalRedpackageMoney = 0;
      // this.guiderDetails.billDetailsBoList.forEach(v => {
      //   v.guiderName = this.guiderDetails.guiderName;
      //   this.guiderDetails.totalRedpackageMoney += v.redpackageMoney;
      // });

      // this.guiderDetails.declareImgList = this.guiderDetails.declareImg.split(
      //   ","
      // );
    },
    async detail(row) {
      this.detailsFx = row;
      this.dialogDeclares = true;
      const { result } = await this.$store.dispatch(
        "queryDetailsShareAgentFlow",
        {
          orderSn: row.orderSn,
          obtainCommissionId: row.obtainCommissionId,
          commissionType: row.commissionType
        }
      );
      let total = 0;
      result.map(v => {
        total += v.commissionMoney;
      });
      this.billDetail = result;
      this.commissionTotalMoney = total.toFixed(2);
    },
    // 导出excel
    output(funcName, title, table) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func(this.currentRow)
          .then(res => {
            const list = res.result.records;

            const tHeader = this.$refs[table].columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs[table].$children
                .map(o => o._props.prop)
                .filter(o => o);
            }

            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 移除上传文件
    handleRemove() {
      this.listHeaderImgUrl = "";
    },
    toggleShow() {
      this.show = !this.show;
    },
    async queryStoreBasicList() {
      const { result } = await this.$store.dispatch(
        "queryStoreBasicListComboBox"
      );
      this.allStoreBasicList = result || [];
    },
    remoteMethod(query) {
      if (query !== '') {
        this.storeBasicList = this.allStoreBasicList.filter(v => v.storeName.indexOf(query) > -1);
      } else {
        this.storeBasicList = [];
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.table {
  padding: 10px 0;
}
.tips {
  color: #999;
  font-size: 12px;
  line-height: 20px;
}
.priview {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;

  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.modal-table {
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  .table-header {
    background: #f7f7f7;
    > div {
      padding: 15px;
      color: #222;
    }
  }
  .table-body {
    padding: 15px;
  }
}
</style>
